var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
import warning from '../_util/warning';
import { composeRef } from '../_util/ref';
const Typography = (_a, ref) => {
    var { prefixCls: customizePrefixCls, component = 'article', className, 'aria-label': ariaLabel, setContentRef, children } = _a, restProps = __rest(_a, ["prefixCls", "component", "className", 'aria-label', "setContentRef", "children"]);
    let mergedRef = ref;
    if (setContentRef) {
        warning(false, 'Typography', '`setContentRef` is deprecated. Please use `ref` instead.');
        mergedRef = composeRef(ref, setContentRef);
    }
    return (<ConfigConsumer>
      {({ getPrefixCls, direction }) => {
        const Component = component;
        const prefixCls = getPrefixCls('typography', customizePrefixCls);
        const componentClassName = classNames(prefixCls, className, {
            [`${prefixCls}-rtl`]: direction === 'rtl',
        });
        return (<Component className={componentClassName} aria-label={ariaLabel} ref={mergedRef} {...restProps}>
            {children}
          </Component>);
    }}
    </ConfigConsumer>);
};
let RefTypography;
if (React.forwardRef) {
    RefTypography = React.forwardRef(Typography);
    RefTypography.displayName = 'Typography';
}
else {
    class TypographyWrapper extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {};
        }
        render() {
            return <Typography {...this.props}/>;
        }
    }
    RefTypography = TypographyWrapper;
}
// es default export should use const instead of let
const ExportTypography = RefTypography;
export default ExportTypography;
